import { useState } from "react";
import { motion } from "framer-motion";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import "./styles/FAQ.css"; // Import the CSS file
import Footer from "./Footer";


const faqs = {
    Caregiver: [
      {
        question: "How do I request Paid Time Off (PTO)?",
        answer:
          "To request PTO, log in to your employee portal and navigate to the 'Time Off Requests' section. Select the desired dates and submit your request for approval. Keep in mind that PTO eligibility depends on your agency’s policies, your working hours, and state labor laws. It’s always best to plan in advance and notify your supervisor before taking time off.",
      },
      {
        question: "What are the work hour limits?",
        answer:
          "The number of hours you can work depends on the care plan authorized by the state. Generally, caregivers can work up to 40 hours per week. However, in some cases, overtime may be permitted if additional care hours are medically necessary. Always check with your agency to confirm your work-hour limits and any overtime policies.",
      },
      {
        question: "How can I get a copy of my paycheck stub?",
        answer:
          "You can access your paycheck stub through the payroll portal provided by your agency. Simply log in, go to the 'Payroll' section, and select the paycheck you want to view or download. If you encounter any issues, contact HR or your payroll department for assistance.",
      },
      {
        question: "How do holiday schedules work?",
        answer:
          "Holiday pay varies depending on your agency’s policies. Some agencies offer time-and-a-half pay for working on holidays, while others may provide an additional paid day off. If you are scheduled to work on a holiday, confirm with your employer whether extra pay or time off is provided.",
      },
      {
        question: "Who can submit timesheets?",
        answer:
          "Timesheets must be submitted by caregivers or an authorized representative. It’s crucial to ensure accuracy when recording work hours, as incorrect submissions may lead to payment delays. Timesheets should be submitted by the deadline set by your agency to avoid payroll processing issues.",
      },
    ],
    Client: [
      {
        question: "What services can PCAs provide for minors?",
        answer:
          "Personal Care Assistants (PCAs) provide essential support to children with disabilities or special needs. Services may include assistance with daily living activities such as dressing, grooming, mobility support, feeding, and personal hygiene. Additionally, PCAs may help with supervision to ensure the child’s safety. The scope of services is determined by the child’s care plan and medical needs.",
      },
      {
        question: "What is the role of a Responsible Party?",
        answer:
          "A Responsible Party (RP) is a designated adult who ensures that the PCA provides care according to the authorized plan. This role is crucial for minors, individuals with cognitive impairments, or those unable to manage their own care. The RP oversees the PCA’s activities, communicates with healthcare professionals, and ensures compliance with state regulations.",
      },
      {
        question: "How many hours of PCA service am I eligible for?",
        answer:
          "The number of PCA hours you qualify for is determined by a state-assigned Public Health Nurse (PHN) during an in-home assessment. The assessment considers medical conditions, physical and cognitive abilities, and daily living needs. The approved hours are based on state guidelines and must be reassessed periodically.",
      },
      {
        question: "How long is my PCA service authorized?",
        answer:
          "Typically, PCA services are authorized for a 12-month period, after which a reassessment is required to determine continued eligibility. However, if there are significant changes in the client’s health condition, a reassessment may be conducted sooner. Clients should keep track of their service expiration date and schedule reassessments in advance to avoid service interruptions.",
      },
      {
        question: "What are Qualified Professional (QP) visits?",
        answer:
          "Qualified Professional (QP) visits are routine check-ins conducted by a healthcare professional to monitor the quality of PCA services. During these visits, the QP ensures that the care plan is being followed, addresses any concerns, and provides necessary training to PCAs. These visits help maintain compliance with state regulations and improve the overall quality of care.",
      },
    ],
  };

const FAQ = () => {
  const [openFAQ, setOpenFAQ] = useState(null);
  const [activeCategory, setActiveCategory] = useState("Caregiver");

  const toggleFAQ = (index) => {
    setOpenFAQ(openFAQ === index ? null : index);
  };

  return (
    <>
    <section className="hero">
        
     
        <div className="wrap"></div>
          <div className="container">
  
          <div className="hero-content">
            <h1>FAQs</h1>
            <p>Ensuring compliance and accountability in home healthcare services.</p>
          </div>
          </div>
        </section>

    <div className="faq-container">
         
      <h2 className="faq-title">Frequently Asked Questions</h2>

      {/* Category Tabs */}
      <div className="faq-tabs">
        {Object.keys(faqs).map((category) => (
          <button
            key={category}
            className={`faq-tab ${activeCategory === category ? "active" : ""}`}
            onClick={() => setActiveCategory(category)}
          >
            {category} FAQ
          </button>
        ))}
      </div>

      {/* FAQ List */}
      <div className="faq-list">
        {faqs[activeCategory].map((item, index) => (
          <div key={index} className="faq-item">
            <button className="faq-question" onClick={() => toggleFAQ(index)}>
              {item.question}
              {openFAQ === index ? <FaChevronUp /> : <FaChevronDown />}
            </button>

            <motion.div
              initial={{ height: 0, opacity: 0 }}
              animate={openFAQ === index ? { height: "auto", opacity: 1 } : { height: 0, opacity: 0 }}
              className="faq-answer"
            >
              <p>{item.answer}</p>
            </motion.div>
          </div>
        ))}
      </div>
    </div>
    <footer>
        <Footer />
    </footer>
    </>
  );
};

export default FAQ;
